import React from 'react'
import AiButton, { type AiButtonProps } from '../ai-button/AiButton'
import { useAiButton } from '../ai-button/useAiButton'
import { useAiAgent } from '../../../utils/contexts/ai/AiAgentContext'

export interface AiButtonOpenChatProps extends AiButtonProps {
  showCtaInitially?: boolean
  onCtaTryIt?: () => void
  onCtaClose?: () => void
}

export const AiButtonOpenChat: React.FC<AiButtonOpenChatProps> = ({
  showCtaInitially = true,
  onCtaTryIt,
  onCtaClose,
  ...props
}) => {
  const { isAgentEnabled, openChat, isAgentPowered } = useAiAgent()

  const { showCtaModal, showCtaInsteadOfButton, handleCtaTryIt, handleCtaClose } = useAiButton(
    onCtaTryIt || openChat,
    onCtaClose,
    showCtaInitially
  )

  const aiButton = (
    <AiButton
      {...props}
      onClick={openChat}
      isPowered={isAgentEnabled && isAgentPowered}
      showCtaModal={showCtaModal}
      onCtaTryIt={handleCtaTryIt}
      onCtaClose={handleCtaClose}
      showCtaInsteadOfButton={showCtaInsteadOfButton}
    />
  )

  return <>{isAgentPowered && isAgentEnabled && aiButton}</>
}
